'use client'
import EmbeddedCoursesPage from "@/components/page-partials/embedded/EmbeddedCoursesPage"

function Page() {
  return <EmbeddedCoursesPage />
}

export default Page
